import React, {useEffect, useState} from 'react';
import axios from 'axios';
import config from '../../config/apiConfig';
//loading
import BeatLoader from "react-spinners/BeatLoader";
import { getSucursalActiva } from '../Utiles/Sucursales';
import TarjetaMenu from '../Navegacion/TarjetaMenu';
import { css } from "@emotion/react";


function VentasHome(props) {

    const  [items, setItems] = useState([]);
    const  [loading, setLoading] = useState(false);
    
    const override = css`
        display: block;
        margin: 0 auto;
        border-color: red;
    `;

    useEffect(()=>{
        let token = localStorage.getItem("token");      
        axios.defaults.headers.common["token"] = token;
        getItems()
    },[]);
    

    async function getItems(){
        setLoading(true)
        await axios.get(config.api_url+'/configuracion/menu/items/?menuId=1').then(resp=>{
            console.log(resp.data)
            if (resp.data.completado){
                 setItems(resp.data.items)
                 setLoading(false)
            }
        }).catch(error=>{
            setLoading(false)
            alert('Se ha provocado un error');
        })
    }

    return (
        
        <div className="contenedorHome" style={{padding:"10px"}}> 
            <div className="card" >
                    <div className="card-header">
                        <div className="titulo-formulario d-flex justify-content-center"  >
                            <div className="col-md-12"> <i className="bi bi-basket"></i> Ventas</div>
                        </div>   
                    </div>
                    <div className="car-body" style={{paddingLeft:"5%", paddingRight:"5%"}}>
                    <br></br>
                    <BeatLoader color={config.color_loader} loading={loading} css={override} size={50} />
                    <div className="row">
                        {items.map(item=>
                            <TarjetaMenu item={item}/>
                        )}
                    </div>
                </div>
            </div> 
        </div> 
        
  
  );
}

export default VentasHome;